import moment from "moment";
import { LookupValue } from "../common/lookup-value";
import { Address } from "./address";
import { MemberRisk } from "./member-risk";
import { PhoneNumber } from "./phone-number";

export class Member {
  id: number;
  gender: LookupValue;
  prefix: LookupValue;
  suffix: LookupValue;
  tenantId: number;
  riskScore: number;
  teamId: number;
  createdById: number;
  updatedById: number;
  activatedById: number;
  deactivatedById: number;
  referralById: number;
  firstName: string;
  lastName: string;
  middleInitial: string;
  createdBy: string;
  updatedBy: string;
  emailAddress: string;
  nickName: string;
  teamName: string;
  status: string;
  activatedBy: string;
  deactivatedBy: string;
  referredBy: string;
  birthDate: string;
  createdDatetime: string;
  updatedDatetime: string;
  activatedDatetime: string;
  deactivatedDatetime: string;
  referralDatetime: string;
  isDeleted: boolean;
  isSsnUnknown: boolean;
  isActive: boolean;
  addresses: Address[];
  phoneNumbers: PhoneNumber[];
  memberRisks: MemberRisk[];
  ssn: string;
  note: string;

  getBirthDateDisplayValue(): string {
    let displayValue = "";
    if (this.birthDate) {
      let age = moment().diff(moment(this.birthDate, "YYYY-MM-DD"), "years");
      displayValue =
        age +
        " year(s) ( " +
        moment(this.birthDate, "YYYY-MM-DD").format("MM/DD/YYYY") +
        " )";
    }
    return displayValue;
  }

  getSsnDisplayValue(): string {
    if (!this.ssn || this.ssn.length < 11) return "";
    return "***-**-" + this.ssn.substring(7, 11);
  }

  getGenderDisplayValue(): string {
    if (this.gender) {
      return this.gender.description;
    }
    return "";
  }

  getPrefixDisplayValue(): string {
    if (this.prefix) {
      return this.prefix.description;
    }
    return "";
  }

  getSuffixDisplayValue(): string {
    if (this.suffix) {
      return this.suffix.description;
    }
    return "";
  }

  getAddressByType(addressType: string): Address {
    let addressObj = null;
    for (let address of this.addresses) {
      if (address.addressTypeId) {
        switch (addressType) {
          case "home":
            if (address.addressTypeId.id == 1) {
              addressObj = address;
            }
            break;

          case "referral":
            if (address.addressTypeId.id == 2) {
              addressObj = address;
            }
            break;
        }
      }
    }

    return addressObj;
  }

  getPhoneNumberDisplayValue() {
    let phoneNumber = "";

    for (let phoneObj of this.phoneNumbers) {
      if (phoneObj.number) {
        phoneNumber = phoneObj.number.toString();
        break;
      }
    }

    return phoneNumber;
  }
}



// WEBPACK FOOTER //
// ./src/models/community-bereavement/member.ts